<script>
import iconosOta from "./iconosOta";

export default {
  props: {
    channel_id: {
      type: Number,
    },
    styleIcon: {
      type: Number,
    },
  },
  created() {
    this.iconos = iconosOta;
  },
};
</script>
<template>
  <div class="icon-ota" style="margin-left: 4px">
    <svg
      v-if="channel_id === 1"
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      :style="styleIcon ? { width: styleIcon + 'px', height: styleIcon + 'px' } : { width: '25px' }"
    >
      <g fill="none" fill-rule="evenodd">
        <g>
          <g transform="translate(-58 -320) translate(58 320)">
            <circle cx="12" cy="12" r="12" fill="#0C3B7C"></circle>
            <path
              fill="#FFF"
              d="M12.683 15.8l-2.184-.002v-2.615c0-.559.216-.85.694-.916h1.49c1.062 0 1.75.67 1.75 1.757 0 1.115-.67 1.776-1.75 1.777zm-2.184-7.054v-.688c0-.603.254-.89.812-.926h1.118c.959 0 1.533.574 1.533 1.536 0 .732-.394 1.587-1.498 1.587H10.5V8.746zm4.973 2.61l-.395-.222.345-.295c.401-.346 1.073-1.122 1.073-2.462C16.495 6.325 14.906 5 12.447 5H9.64V5h-.32c-.728.027-1.312.62-1.32 1.355V18h4.502C15.236 18 17 16.51 17 14.202c0-1.243-.57-2.305-1.528-2.846"
            ></path>
            <path
              fill="#00BAFC"
              d="M18 16.5c0-.83.67-1.5 1.497-1.5.829 0 1.503.67 1.503 1.5 0 .828-.674 1.5-1.503 1.5-.826 0-1.497-.672-1.497-1.5"
            ></path>
          </g>
        </g>
      </g>
    </svg>

    <svg
      v-else-if="channel_id === 2"
      enable-background="new 0 0 512 512"
      id="Layer_1"
      version="1.1"
      viewBox="0 0 512 512"
      xml:space="preserve"
      xmlns="http://www.w3.org/2000/svg"
      xmlns:xlink="http://www.w3.org/1999/xlink"
      :style="styleIcon ? { width: styleIcon + 'px', height: styleIcon + 'px' } : { width: '25px' }"
    >
      <circle
        cx="256"
        cy="256"
        fill="#FD5C63"
        r="256"
      ></circle>
      <g id="Layer_2" >
        <g>
          <path
            d="M361.2,297.9c-1.9-4.3-3.9-8.4-5.6-12.3l-0.2-0.2c-16.7-36-34.5-72.6-53.3-108.6l-0.7-1.4    c-1.9-3.6-3.9-7.4-5.8-11.3c-2.4-4.3-4.8-8.9-8.7-13.2c-7.7-9.6-18.8-14.9-30.6-14.9c-12.1,0-22.9,5.3-30.9,14.4    c-3.6,4.3-6.3,8.9-8.7,13.2c-1.9,3.8-3.9,7.7-5.8,11.3l-0.7,1.4c-18.6,36-36.7,72.6-53.3,108.6l-0.2,0.5    c-1.7,3.8-3.6,7.9-5.6,12.3c-1.2,2.6-2.4,5.5-3.6,8.6c-3.1,8.9-4.1,17.3-2.9,25.9c2.7,18,14.7,33.2,31.4,39.9    c6.3,2.6,12.8,3.8,19.5,3.8c1.9,0,4.3-0.2,6.3-0.5c8-1,16.2-3.6,24.1-8.2c9.9-5.5,19.3-13.5,29.9-25c10.6,11.5,20.3,19.5,29.9,25    c8,4.6,16.2,7.2,24.1,8.2c1.9,0.2,4.3,0.5,6.3,0.5c6.8,0,13.5-1.2,19.5-3.8c16.9-6.7,28.7-22.1,31.4-39.9c1.9-8.4,1-16.8-2.2-25.7    C363.6,303.7,362.4,300.6,361.2,297.9z M256,319.1c-13-16.3-21.5-31.7-24.4-44.7c-1.2-5.5-1.4-10.3-0.7-14.7    c0.5-3.8,1.9-7.2,3.9-10.1c4.6-6.5,12.3-10.6,21.2-10.6c8.9,0,16.9,3.8,21.2,10.6c1.9,2.9,3.4,6.3,3.9,10.1    c0.7,4.3,0.5,9.4-0.7,14.7C277.5,287.1,269,302.5,256,319.1z M352.3,330.4c-1.7,12.5-10.1,23.3-22,28.1    c-5.8,2.4-12.1,3.1-18.3,2.4c-6-0.7-12.1-2.6-18.3-6.2c-8.7-4.8-17.4-12.3-27.5-23.3c15.9-19.5,25.6-37.2,29.2-53.1    c1.7-7.4,1.9-14.2,1.2-20.4c-1-6-3.1-11.5-6.5-16.3c-7.5-10.8-20-17.1-34-17.1c-14,0-26.5,6.5-34,17.1c-3.4,4.8-5.6,10.3-6.5,16.3    c-1,6.2-0.7,13.2,1.2,20.4c3.6,15.9,13.5,33.9,29.2,53.3c-9.9,11.1-18.8,18.5-27.5,23.3c-6.3,3.6-12.3,5.5-18.3,6.2    c-6.5,0.7-12.8-0.2-18.3-2.4c-11.8-4.8-20.3-15.6-22-28.1c-0.7-6-0.2-12,2.2-18.7c0.7-2.4,1.9-4.8,3.1-7.7c1.7-3.8,3.6-7.9,5.6-12    l0.2-0.5c16.7-35.8,34.5-72.3,53.1-107.9l0.7-1.4c1.9-3.6,3.9-7.4,5.8-11c1.9-3.8,4.1-7.4,6.8-10.6c5.1-5.8,11.8-8.9,19.3-8.9    c7.5,0,14.2,3.1,19.3,8.9c2.7,3.1,4.8,6.7,6.8,10.6c1.9,3.6,3.9,7.4,5.8,11l0.7,1.4c18.3,35.8,36.2,72.3,52.9,108.1v0.2    c1.9,3.8,3.6,8.2,5.6,12c1.2,2.9,2.4,5.3,3.1,7.7C352.5,318.1,353.3,324.1,352.3,330.4z"
            fill="#FFFFFF"
          ></path>
        </g>
      </g>
    </svg>

    <div
      v-else-if="channel_id === 3"
      class="d-flex"
      style="
        width: 26px;
        height: 26px;
        border-radius: 50px;
        justify-content: center;
        align-items: center;
      "
      :style="
        styleIcon
          ? {
              width: styleIcon + 'px !important',
              height: styleIcon + 'px !important',
            }
          : {}
      "
    >
      <img
        :src="iconos.vrboFondo"
        alt="Vrbo"
        decoding="sync"
        class="img-fluid"
        style="margin-right: 0px"
      />
    </div>

    <div
      v-else-if="channel_id === 4"
      class="d-flex"
      style="
        width: 23px;
        height: 23px;
        background: rgb(255 255 255);
        border-radius: 50px;
        justify-content: center;
        align-items: center;
      "
      :style="
        styleIcon
          ? {
              width: styleIcon + 'px !important',
              height: styleIcon + 'px !important',
            }
          : {}
      "
    >
      <img
        :src="iconos.expedia"
        alt="Expedia"
        decoding="sync"
        class="img-fluid"
        style="margin-right: 0px"
      />
    </div>

    <div
      v-else-if="channel_id === 6"
      class="d-flex"
      style="
        width: 26px;
        height: 26px;
        background: rgb(255 255 255);
        border-radius: 50px;
        justify-content: center;
        align-items: center;
        overflow: hidden;
      "
      :style="
        styleIcon
          ? {
              width: styleIcon + 'px !important',
              height: styleIcon + 'px !important',
            }
          : {}
      "
    >
      <img
        :src="iconos.bedAndBreakfast"
        alt="Bed-and-Breakfast.it"
        decoding="sync"
        class="img-fluid"
        style="width: 100%; height: 100%; object-fit: cover; margin-right: 0px"
      />
    </div>

    <div
      v-else-if="channel_id === 7"
      class="d-flex"
      style="width: 26px; height: 26px; background: #fff; border-radius: 50px; justify-content: center; align-items: center; overflow: hidden;"
      :style="styleIcon ? { width: styleIcon + 'px !important', height: styleIcon + 'px !important' } : {}"
    >
      <svg width="17" height="17" viewBox="0 0 48 48" xmlns="http://www.w3.org/2000/svg">
        <path fill="#FFC107" d="M43.611 20.083H42V20H24v8h11.303c-1.649 4.657-6.08 8-11.303 8-6.627 0-12-5.373-12-12s5.373-12 12-12c3.059 0 5.842 1.154 7.961 3.039l5.657-5.657C34.046 6.053 29.268 4 24 4 12.955 4 4 12.955 4 24s8.955 20 20 20 20-8.955 20-20c0-1.341-.138-2.65-.389-3.917z"/>
        <path fill="#FF3D00" d="M6.306 14.691l6.571 4.819C14.655 15.108 18.961 12 24 12c3.059 0 5.842 1.154 7.961 3.039l5.657-5.657C34.046 6.053 29.268 4 24 4 16.318 4 9.656 8.337 6.306 14.691z"/>
        <path fill="#4CAF50" d="M24 44c5.166 0 9.86-1.977 13.409-5.192l-6.19-5.238A11.91 11.91 0 0 1 24 36c-5.202 0-9.619-3.317-11.283-7.946l-6.522 5.025C9.505 39.556 16.227 44 24 44z"/>
        <path fill="#1976D2" d="M43.611 20.083H42V20H24v8h11.303a12.04 12.04 0 0 1-4.087 5.571l.003-.002 6.19 5.238C36.971 39.205 44 34 44 24c0-1.341-.138-2.65-.389-3.917z"/>
      </svg>
    </div>

    <!-- Agoda. Mismo disco blanco que Google: su icono ya lleva sus colores. -->
    <div
      v-else-if="channel_id === 8"
      class="d-flex"
      style="width: 26px; height: 26px; background: #fff; border-radius: 50px; justify-content: center; align-items: center; overflow: hidden;"
      :style="styleIcon ? { width: styleIcon + 'px !important', height: styleIcon + 'px !important' } : {}"
    >
      <img :src="iconos.agoda" alt="Agoda" decoding="sync" style="width: 19px; height: 19px; object-fit: contain;" />
    </div>


    <!-- Hotelbeds. Marca provisional dibujada a mano hasta que el cliente nos
         pase su logotipo oficial; va sobre el mismo disco blanco que las demás. -->
    <div
      v-else-if="channel_id === 9"
      class="d-flex"
      style="width: 26px; height: 26px; background: #fff; border-radius: 50%; justify-content: center; align-items: center; overflow: hidden; flex-shrink: 0;"
      :style="styleIcon ? { width: styleIcon + 'px !important', height: styleIcon + 'px !important' } : {}"
    >
      <img :src="iconos.hotelbeds" alt="Hotelbeds" decoding="sync" style="width: 19px; height: 19px; object-fit: contain;" />
    </div>

    <div
      v-else
      class="d-flex"
      style="
        width: 28px;
        height: 28px;
        background: rgb(236 236 236);
        border-radius: 50px;
        justify-content: center;
        align-items: center;
      "
      :style="
        styleIcon
          ? {
              width: styleIcon + 'px !important',
              height: styleIcon + 'px !important',
            }
          : {}
      "
    >
      <img
        :src="iconos.wacheckin"
        alt="WACheckin"
        decoding="sync"
        class="img-fluid"
        style="width: 12px; margin-right: 0px"
      />
    </div>
  </div>
</template>
